import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@project-stories/elements/Image/Image";

export default function GridTwoColumns({ settings, blocks }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layoutType = isMobile
    ? settings.section.layout_mobile
    : settings.section.layout;

  return (
    <div className={`expertise-${layoutType} flex gap-8`}>
      <div className={`flex flex-col gap-4 items-center justify-between w-[386px] shrink-0`}>
        <div className="flex flex-col gap-11">
          <div className="flex flex-col gap-3">
            {settings.section.tagline && (
              <div className={`${isMobile ? settings.section.tagline_style_mobile : settings.section.tagline_style}`}>
                {settings.section.tagline}
              </div>
            )}

            <div className={`${isMobile ? settings.section.title_font_type_mobile : settings.section.title_font_type}`}>
              {settings.section.title}
            </div>
          </div>
          <div className={`${isMobile ? settings.section.subtitle_style_mobile : settings.section.subtitle_style}`}>
            {settings.section.subtitle}
          </div>
        </div>
        
        {settings.section.cta_text && (
          <div className={`${isMobile ? settings.section.cta_text_style_mobile : settings.section.cta_text_style}`}>
            {settings.section.cta_text}
          </div>
        )}
      </div>
      <div className={`flex-1 overflow-x-auto no-scrollbar`}>
        <div
          className={`border-card grid grid-flow-col
            auto-cols-[${settings.section.min_width > 0
              ? `minmax(${settings.section.min_width}px,1fr)`
              : `1fr`
            }] 
            ${isMobile ? `gap-x-[${settings.section.gap_x_mobile}px] gap-y-[${settings.section.gap_y_mobile}px]`
              : `gap-x-[${settings.section.gap_x}px] gap-y-[${settings.section.gap_y}px]`} 
          `}
          style={{
            gridTemplateRows: `repeat(${isMobile ? settings.section.rows_mobile : settings.section.rows}, minmax(0, 1fr))`,
            gridAutoColumns: settings.section.min_width > 0
              ? `minmax(${settings.section.min_width}px, 1fr)`
              : '1fr',
          }}
        >
          {blocks.map((block, index) => (
            <div key={index} className={`tileitem-border col-span-1 p-8`}>

              <Image imageUrl={block.settings.image_icon} alt={block.settings.title} classes="h-8 w-8" />

              <div className={`${isMobile ? block.settings.title_font_type_mobile : block.settings.title_font_type} mt-8`}>{block.settings.title}</div>
              <div className={`${isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style} mt-8`}>{block.settings.content}</div>
              {(() => {
                const texts = Array.from({ length: 4 }, (_, i) => {
                  const key = `text_${i + 1}`;

                  return block.settings[key];
                }).filter(Boolean);

                return texts.length > 0 ? (
                  <div className={`flex flex-wrap gap-2 mt-5`}>
                    {texts.map((value, idx) => (
                      <p
                        key={`text_${idx + 1}`}
                        className={`${isMobile ? block.settings.text_font_style_mobile : block.settings.text_font_style} px-3 py-2 rounded-full bg-[#D6CFF8]`}
                      >
                        {value}
                      </p>
                    ))}
                  </div>
                ) : null;
              })()}
              {block.settings.cta_url &&
                <a
                  href={block.settings.cta_url}
                  target={block.settings.is_open_in_new_tab ? "_blank" : "_self"}
                  className="link link-primary inline-block cursor-pointer py-3 pr-6 mt-5"
                >
                  <span className="button__label">{block.settings.cta_text}</span>
                  <span className="icon-right-arrow-alt button__icon no-underline"></span>
                </a>
              }
            </div>
          ))}
        </div>
      </div >
    </div>
  )
}